import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/supabase';

// Get environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validate environment variables
console.log('[Supabase] Environment check:', {
  hasUrl: !!supabaseUrl,
  hasKey: !!supabaseKey,
  url: supabaseUrl
});

if (!supabaseUrl || !supabaseKey) {
  console.error('[Supabase] Missing environment variables!');
  throw new Error('Missing Supabase configuration');
}

// Create Supabase client
export const supabase = createClient<Database>(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'cyberedge.auth.token'
  },
  global: {
    headers: {
      'x-client-info': 'cyberedge-web'
    }
  }
});

console.log('[Supabase] Client initialized successfully');

export default supabase;